import { Copy06Icon } from '@repo/studio-design-system-ui-icons/general/copy-06'
import { lazyToast } from '@repo/studio-components-toast'
import { useTranslation } from 'react-i18next'

function CopyToast({ message }: { message: string }) {
  return (
    <div className="rounded-4 bg-gray-1000 flex flex-row items-center gap-2 whitespace-nowrap p-4">
      <div className="flex h-6 w-6 items-center justify-center">
        <Copy06Icon />
      </div>
      <p>{message}</p>
    </div>
  )
}

/** The toast every copy action shows, for copies that don't go through {@link useCopyToClipboard}. */
export function showCopyToast(message: string) {
  lazyToast().then(toast =>
    toast.custom(() => <CopyToast message={message} />, {
      className: 'bg-transparent',
      duration: 3000,
    }),
  )
}

export function useCopyToClipboard() {
  const { t } = useTranslation('components')

  function copyToClipboard(
    textToCopy: string | null | undefined,
    options?: { toastMessage?: string },
  ) {
    if (!textToCopy) {
      return
    }

    const message = options?.toastMessage ?? t('studio.components.clipboard')

    navigator.clipboard.writeText(textToCopy)
    showCopyToast(message)
  }

  return copyToClipboard
}
